import { columns } from "../../../../dtos/columns";
import { ErrorCarga } from "../components/models/comunModels";


export function useColumnsError() {

    const COLUMNS: columns<ErrorCarga>[] = [
        {
            name: 'Campo',
            selector: (row) =>
                row.campo ? row.campo : "N/A",
            sortable: true,
            sortField: 'campo',
            wrap: true,
            export: true
        },
        {
            name: 'Número línea',
            selector: (row) => row.numeroLinea,
            sortable: true,
            sortField: 'numeroLinea',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Descripción error',
            selector: (row) =>
                row.descripcionError,
            sortable: true,
            sortField: 'descripcionError',
            wrap: true,
            export: true,
        }
    ]


    return { COLUMNS };
}